var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.872506,
    y: 1.0185,
    width: 36.8548,
    height: 36.8866,
    rx: 4.5274,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.872506,
    y: 1.0185,
    width: 36.8548,
    height: 36.8866,
    rx: 4.5274,
    stroke: "#DEDFEC",
    strokeWidth: 0.945207
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7959 29.5459L11.2017 24.41C10.3342 22.9067 9.8784 21.2025 9.87923 19.455C9.88173 13.9917 14.3276 9.5459 19.79 9.5459C22.4409 9.54673 24.9292 10.5792 26.8009 12.4526C28.6717 14.3259 29.7017 16.8159 29.7009 19.4642C29.6984 24.9284 25.2525 29.3742 19.79 29.3742C18.1317 29.3734 16.4976 28.9575 15.0501 28.1675L9.7959 29.5459ZM15.2934 26.3734C16.69 27.2025 18.0234 27.6992 19.7867 27.7C24.3267 27.7 28.025 24.005 28.0275 19.4625C28.0292 14.9109 24.3484 11.2209 19.7934 11.2192C15.2501 11.2192 11.5542 14.9142 11.5526 19.4559C11.5517 21.31 12.0951 22.6984 13.0076 24.1509L12.1751 27.1909L15.2934 26.3734ZM24.7825 21.82C24.7209 21.7167 24.5559 21.655 24.3075 21.5309C24.06 21.4067 22.8425 20.8075 22.615 20.725C22.3884 20.6425 22.2234 20.6009 22.0575 20.8492C21.8925 21.0967 21.4175 21.655 21.2734 21.82C21.1292 21.985 20.9842 22.0059 20.7367 21.8817C20.4892 21.7575 19.6909 21.4967 18.745 20.6525C18.0092 19.9959 17.5117 19.185 17.3675 18.9367C17.2234 18.6892 17.3525 18.555 17.4759 18.4317C17.5875 18.3209 17.7234 18.1425 17.8475 17.9975C17.9734 17.8542 18.0142 17.7509 18.0975 17.585C18.18 17.42 18.1392 17.275 18.0767 17.1509C18.0142 17.0275 17.5192 15.8084 17.3134 15.3126C17.1117 14.8301 16.9075 14.8951 16.7559 14.8876L16.2809 14.8792C16.1159 14.8792 15.8476 14.9409 15.6209 15.1892C15.3942 15.4376 14.7542 16.0359 14.7542 17.255C14.7542 18.4742 15.6417 19.6517 15.7651 19.8167C15.8892 19.9817 17.5109 22.4834 19.995 23.5559C20.5859 23.8109 21.0475 23.9634 21.4067 24.0775C22 24.2659 22.54 24.2392 22.9667 24.1759C23.4425 24.105 24.4317 23.5767 24.6384 22.9984C24.845 22.4192 24.845 21.9234 24.7825 21.82Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsAppIcon);
export default __webpack_public_path__ + "static/media/WhatsAppIcon.317f15e78fa3c795b02360f9b29fb13a.svg";
export { ForwardRef as ReactComponent };